import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import {
  jsxFormat,
  localeMap,
  numberFormat,
} from 'utils/currencyFormat';
import { locale } from 'utils/locale';

import localize from 'components/Localize/Localize';

import styles from './PriceGroup.css';
import translations from './translations';

const cx = classNames.bind(styles);

const TaxIncluded = (props) => {
  if (!props.content) {
    return null;
  }

  return <div className={styles[`tax-included`]}>{props.content}</div>;
};

/*
 * @todo implement currency with native javascript functionality, which
 * will also determine its placement before or after the price number.
 */
class PriceGroup extends React.Component {
  renderPrice() {
    const localeData = localeMap[this.props.locale];
    const localeHelper = locale(this.props.locale);
    const currencyClass = cx(`price`, {
      'currency--dach': localeHelper.isDACH(),
      'currency--cad': localeHelper.isCA(),
      'currency--chf': localeHelper.isCH(),
    });
    const currency = (
      <span
        className={currencyClass}
        key={localeData.currency}
      >
        {localeData.currency}
      </span>
    );
    const price = numberFormat(this.props.price, this.props.locale);
    const amount = (
      <span
        className={styles[`price`]}
        key={this.props.price}
      >
        {price}
      </span>
    );

    return jsxFormat(amount, currency, this.props.locale);
  }

  render() {
    return (
      <div className={styles[`container`]}>
        {this.renderPrice()}
        <TaxIncluded content={this.props.t.taxIncluded} />
      </div>
    );
  }
}

PriceGroup.propTypes = {
  locale: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  t: PropTypes.shape({
    taxIncluded: PropTypes.string,
  }),
};

export default localize(PriceGroup, translations);
